import React from 'react'
import BriefSlider from './BriefSlider'

const Brief = () => {
  return (
    <section className='brief'>
      <div className='center'>
        <h2>Depoimentos</h2>
        <BriefSlider />
      </div>
    </section>
  )
}

export default Brief
